import { render, staticRenderFns } from "./FeatureBanner.vue?vue&type=template&id=42575656&scoped=true&"
import script from "./FeatureBanner.vue?vue&type=script&lang=js&"
export * from "./FeatureBanner.vue?vue&type=script&lang=js&"
import style0 from "./FeatureBanner.vue?vue&type=style&index=0&id=42575656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42575656",
  null
  
)

export default component.exports